const MAX_LENGTH_FIRST_NAME = 150;
const MAX_LENGTH_LAST_NAME = 150;

export {
  MAX_LENGTH_FIRST_NAME,
  MAX_LENGTH_LAST_NAME,
}
